module.exports = __webpack_public_path__ + "static/media/ChevronUp.1838eab2.svg";